<template>
	<div
		class="statistics-detail-layout"
		:class="[layoutClass, { 'statistics-overview-detail': overviewDetail }]"
	>
		<StatisticsInventoryPanel
			:row="row"
			:inventory="inventory"
			:visible-rows="visibleInventoryRows"
			:selected-item="selectedInventoryItem"
			:panel-class="inventoryPanelClass"
			:is-expanded="inventoryExpanded"
			:expand-title="inventoryExpandTitle"
			:all-groups-expanded="allInventoryGroupsExpanded"
			:get-inventory-name="getInventoryName"
			:is-inventory-group-expanded="isInventoryGroupExpanded"
			@toggle-expand="$emit('toggle-panel', 'inventory')"
			@toggle-all-groups="$emit('toggle-all-inventory-groups')"
			@row-click="$emit('inventory-row-click', $event)"
		/>

		<StatisticsFlawPanel
			:selected-item="selectedInventoryItem"
			:flaws="flaws"
			:panel-class="flawsPanelClass"
			:is-expanded="flawsExpanded"
			:expand-title="flawsExpandTitle"
			:map-loading="mapLoading"
			:map-image="mapImage"
			:map-error="mapError"
			:get-flaw-name="getFlawName"
			:get-inventory-name="getInventoryName"
			:get-inventory-map-title="getInventoryMapTitle"
			:has-inventory-map-position="hasInventoryMapPosition"
			:get-inventory-map-marker-style="getInventoryMapMarkerStyle"
			:get-inventory-map-icon-class="getInventoryMapIconClass"
			@toggle-expand="$emit('toggle-panel', 'flaws')"
			@open-map="$emit('open-map', $event)"
		/>
	</div>
</template>

<script>
import StatisticsFlawPanel from './StatisticsFlawPanel.vue';
import StatisticsInventoryPanel from './StatisticsInventoryPanel.vue';

export default {
	name: 'StatisticsDetailLayout',

	components: {
		StatisticsFlawPanel,
		StatisticsInventoryPanel
	},

	props: {
		allInventoryGroupsExpanded: {
			type: Boolean,
			default: false
		},
		flaws: {
			type: Array,
			default: () => []
		},
		flawsExpanded: {
			type: Boolean,
			default: false
		},
		flawsExpandTitle: {
			type: String,
			required: true
		},
		flawsPanelClass: {
			type: [String, Object, Array],
			default: ''
		},
		getFlawName: {
			type: Function,
			required: true
		},
		getInventoryMapIconClass: {
			type: Function,
			required: true
		},
		getInventoryMapMarkerStyle: {
			type: Function,
			required: true
		},
		getInventoryMapTitle: {
			type: Function,
			required: true
		},
		getInventoryName: {
			type: Function,
			required: true
		},
		hasInventoryMapPosition: {
			type: Function,
			required: true
		},
		inventory: {
			type: Array,
			default: () => []
		},
		inventoryExpanded: {
			type: Boolean,
			default: false
		},
		inventoryExpandTitle: {
			type: String,
			required: true
		},
		inventoryPanelClass: {
			type: [String, Object, Array],
			default: ''
		},
		isInventoryGroupExpanded: {
			type: Function,
			required: true
		},
		layoutClass: {
			type: [String, Object, Array],
			default: ''
		},
		mapError: {
			type: String,
			default: ''
		},
		mapImage: {
			type: String,
			default: ''
		},
		mapLoading: {
			type: Boolean,
			default: false
		},
		overviewDetail: {
			type: Boolean,
			default: false
		},
		row: {
			type: Object,
			required: true
		},
		selectedInventoryItem: {
			type: Object,
			default: null
		},
		visibleInventoryRows: {
			type: Array,
			default: () => []
		}
	}
};
</script>
